import { render, staticRenderFns } from "./BaseAgree.vue?vue&type=template&id=0452385d&scoped=true&"
import script from "./BaseAgree.vue?vue&type=script&lang=js&"
export * from "./BaseAgree.vue?vue&type=script&lang=js&"
import style0 from "./BaseAgree.vue?vue&type=style&index=0&id=0452385d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452385d",
  null
  
)

export default component.exports